import { defineStore } from "pinia";
import router from "../router/index";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    id: null,
    name: null,
    email: null,
    srun_id: null,
    region: null,
    address: null,
    token: null,
    isAuthenticated: false,
  }),

  actions: {
    login(token, userData) {
      this.token = token;
      this.id = userData.id;
      this.name = userData.name;
      this.email = userData.email;
      this.srun_id = userData.srun_id;
      this.region = userData.region;
      this.address = userData.address;
      this.isAuthenticated = true;

      localStorage.setItem("authToken", token);
      localStorage.setItem(
        "userData",
        JSON.stringify({
          id: userData.id,
          name: userData.name,
          email: userData.email,
          srun_id: userData.srun_id,
          region: userData.region,
          address: userData.address,
        })
      );
    },

    setUser(userData) {
      this.id = userData.id;
      this.name = userData.name;
      this.email = userData.email;
      this.srun_id = userData.srun_id;
      this.region = userData.region;
      this.address = userData.address;

      localStorage.setItem(
        "userData",
        JSON.stringify({
          id: userData.id,
          name: userData.name,
          email: userData.email,
          srun_id: userData.srun_id,
          region: userData.region,
          address: userData.address,
        })
      );
    },

    setToken(access_token, expires) {
      this.token = access_token;
      this.isAuthenticated = !!access_token;
      localStorage.setItem("authToken", access_token);
      localStorage.setItem("expireAt", expires);
    },

    logout() {
      this.id = null;
      this.name = null;
      this.email = null;
      this.srun_id = null;
      this.region = null;
      this.address = null;
      this.token = null;
      this.isAuthenticated = false;
      localStorage.removeItem("authToken");
      localStorage.removeItem("userData");
      router.push({ name: "SetPassword" });
    },

    initialize() {
      const token = localStorage.getItem("authToken");
      const userData = localStorage.getItem("userData");


      if (token && userData) {
        this.token = token;
        this.isAuthenticated = true;
        try {
          const parsedUserData = JSON.parse(userData);
          this.setUser(parsedUserData);
        } catch (e) {
          console.error("Failed to parse user data from localStorage", e);
          this.logout();
        }
      }
    },
  },
});
